import { gql } from '@apollo/client';

export const SESSION_STEP_FRAGMENT = gql`
  fragment SessionStepFields on SessionStep {
    _id
    contentType
    contentTitle
    needTagRefetch
    needImmediateTagRefetch
    exercise{
      _id
    }
    content{
      _id
    }
    survey {
      _id
    }
    question {
      _id
    }
    radarFeature {
      _id
    }
    activity{
      _id
      type
    }
    frame {
      layout
      image
      emoji
      title {
        value
        secondaryValue
      }
      texts {
        value
        secondaryValue
      }
    }
    key
    displayResult
    text
    order
  }
`;

export const SESSION_FRAGMENT = gql`
  ${SESSION_STEP_FRAGMENT}
  fragment SessionFields on Session {
    _id
    title
    humanReadableId
    shortDescription
    duration
    totalNumberSteps
    order
    summary
    sessionType
    userSegments
    userSession{
      _id
      order
      done
      wasDoneToday
    }
    mySegmentSteps{
      ...SessionStepFields
    }
  }
`;

export const USER_PATH_FRAGMENT = gql`
  fragment UserPathFields on UserPath {
    _id
    status
    activePathStatus
    numberSessions
    totalNumberSessions
  }
`;

export const PATH_FRAGMENT_BASE = gql`
 fragment PathFieldsBase on Path {
    _id
    humanReadableId
    title
    shortDescription
    longDescription
    hasVideo
    video
    language
    published
    image
    designSystemColor
    wasThePathAlreadyCompleted
 }
`;

export const USER_PATH_FRAGMENT_WITH_TODAY_SESSION = gql`
 ${SESSION_FRAGMENT}
 ${USER_PATH_FRAGMENT}
  fragment UserPathFieldsWithTodaySession on UserPath {
    ...UserPathFields
    todaySessions {
      ...SessionFields
    }
    latestTodaySession {
      _id
    }
  }
`;



export const PATH_FRAGMENT_WITHOUT_SESSION = gql`
  ${USER_PATH_FRAGMENT}
  ${PATH_FRAGMENT_BASE}
    fragment PathFieldsNoSession on Path {
    ...PathFieldsBase
    userPath {
      ...UserPathFields
    }
  }
`;

export const PATH_FRAGMENT_WITH_TODAY_SESSION = gql`
  ${USER_PATH_FRAGMENT_WITH_TODAY_SESSION}
  ${PATH_FRAGMENT_BASE}
    fragment PathFieldsTodaySession on Path {
    ...PathFieldsBase
    userPath {
      ...UserPathFieldsWithTodaySession
    }
  }
`;

export const PATH_FRAGMENT_WITH_SESSION = gql`
  ${SESSION_FRAGMENT}
  ${PATH_FRAGMENT_BASE}
  ${USER_PATH_FRAGMENT_WITH_TODAY_SESSION}
    fragment PathFields on Path {
      ...PathFieldsBase
    userPath {
      ...UserPathFieldsWithTodaySession
    }
    sessions {
      ...SessionFields
    }
  }
`;





export const GET_PATH_WITH_SESSION = gql`
${PATH_FRAGMENT_WITH_SESSION}
  query pathById($id: String!) {
    path(id: $id) {
     ...PathFields
    }
  }
`;

export const GET_PATH_WITH_TODAY_SESSION = gql`
${PATH_FRAGMENT_WITH_TODAY_SESSION}
  query pathById($id: String!) {
    path(id: $id) {
     ...PathFieldsTodaySession
    }
  }
`;